<template>
  <v-dialog v-model="parentPortalConfigurationPresentationDialog" persistent>
    <v-card>
      <v-form ref="portalConfigurationFormRef">
        <v-card-title>
          <span class="headline">Configuration du portail</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-alert v-if="isBuiltIn" type="warning">
              Le portail a un template prédéfini
            </v-alert>
            <v-alert v-if="isInherit" type="warning">
              Le portail hérite des options du groupe
            </v-alert>

            <div id="portal-form" v-if="(isGroup && !isBuiltIn) || !isGroup">
              <v-row no-gutters v-if="!isInherit && !isBuiltIn">
                <v-col cols="12">
                  <v-checkbox
                    v-if="portalConfigurationModel.basic_presentation != null"
                    v-model="hasBasicPresentation"
                    label="has Basic Presentation ?"
                    :rules="[
                      (v) => {
                        if (v && !hasFullPresentation) {
                          return 'Avec une présensation Basic, une présentation Full est également obligatoire';
                        }
                        return true;
                      },
                    ]"
                  ></v-checkbox>

                  <div
                    v-if="
                      portalConfigurationModel.basic_presentation != null &&
                      parentPortalConfiguration.basic_presentation != null
                    "
                  >
                    <h2>Présentation BASIC</h2>

                    <v-radio-group
                      row
                      v-model="
                        parentPortalConfiguration.basic_presentation.payment
                      "
                    >
                      <template
                        v-for="payment in portalConfigurationModel
                          .basic_presentation.payment"
                      >
                        <v-radio
                          :key="payment"
                          :label="payment"
                          :value="payment"
                          :disabled="!hasBasicPresentation"
                        ></v-radio>
                      </template>
                    </v-radio-group>

                    <v-row justify="space-around" no-gutters>
                      <v-col cols="12">
                        <header>Type</header>
                      </v-col>
                      <template
                        v-if="
                          parentPortalConfiguration.basic_presentation
                            .payment === 'free'
                        "
                      >
                        <template
                          v-for="access in portalConfigurationModel
                            .basic_presentation.free_access"
                        >
                          <v-checkbox
                            :key="access"
                            v-model="
                              parentPortalConfiguration.basic_presentation
                                .access
                            "
                            :label="access"
                            :value="access"
                            :disabled="
                              !hasBasicPresentation ||
                              isBasicClickToConnectChecked(access)
                            "
                          ></v-checkbox>
                        </template>
                      </template>
                      <template v-else>
                        <v-radio-group
                          row
                          v-model="
                            parentPortalConfiguration.basic_presentation.access
                          "
                        >
                          <v-radio
                            :key="access"
                            v-for="access in portalConfigurationModel
                              .basic_presentation.chargeable_access"
                            :label="access"
                            :value="access"
                            :disabled="!hasBasicPresentation"
                          ></v-radio>
                        </v-radio-group>
                      </template>
                    </v-row>
                  </div>
                  <v-divider></v-divider>

                  <v-checkbox
                    v-if="portalConfigurationModel.full_presentation != null"
                    v-model="hasFullPresentation"
                    label="has Full Presentation ?"
                  ></v-checkbox>

                  <div
                    v-if="
                      portalConfigurationModel.full_presentation != null &&
                      parentPortalConfiguration.full_presentation != null
                    "
                  >
                    <h2>Présentation FULL</h2>

                    <v-radio-group
                      row
                      v-model="
                        parentPortalConfiguration.full_presentation.payment
                      "
                    >
                      <template
                        v-for="payment in portalConfigurationModel
                          .full_presentation.payment"
                      >
                        <v-radio
                          :key="payment"
                          :label="payment"
                          :value="payment"
                          :disabled="!hasFullPresentation"
                        ></v-radio>
                      </template>
                    </v-radio-group>

                    <v-row no-gutters justify="space-around">
                      <v-col cols="12">
                        <header>Type</header>
                      </v-col>
                      <template
                        v-if="
                          parentPortalConfiguration.full_presentation
                            .payment === 'free'
                        "
                      >
                        <template
                          v-for="access in portalConfigurationModel
                            .full_presentation.free_access"
                        >
                          <v-checkbox
                            :key="access"
                            v-model="
                              parentPortalConfiguration.full_presentation.access
                            "
                            :label="access"
                            :value="access"
                            :disabled="
                              !hasFullPresentation ||
                              isFullClickToConnectChecked(access)
                            "
                          ></v-checkbox>
                        </template>
                      </template>
                      <template v-else>
                        <v-radio-group
                          row
                          v-model="
                            parentPortalConfiguration.full_presentation.access
                          "
                        >
                          <v-radio
                            :key="access"
                            v-for="access in portalConfigurationModel
                              .full_presentation.chargeable_access"
                            :label="access"
                            :value="access"
                            :disabled="!hasFullPresentation"
                          ></v-radio>
                        </v-radio-group>
                      </template>
                    </v-row>
                  </div>
                  <v-divider></v-divider>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="parentPortalConfigurationPresentationDialog = false"
            >Fermer</v-btn
          >
          <v-btn
            color="blue darken-1"
            text
            @click="
              updatePortalConfiguration(
                id,
                parentPortalConfiguration,
                isInherit,
                isBuiltIn,
                portalProfile,
                portalConfigurationFormRef
              )
            "
            >Mettre à jour</v-btn
          >
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { computed, watch } from "@vue/composition-api";
import { usePortalConfiguration } from "@/composables/portal-configuration";

export default {
  props: {
    isInherit: Boolean,
    isBuiltIn: Boolean,
    portalOptionsId: Number,
    isGroup: Boolean,
    updatePortalConfiguration: Function,
    id: String,
    portalConfigurationModel: Object,
    group: Object,
    partner: Object,
    portalConfiguration: {
      type: Object,
      required: true,
    },
    portalConfigurationPresentationDialog: Boolean,
    rules: Object,
  },
  setup(props, { emit }) {
    const parentPortalConfigurationPresentationDialog = computed({
      get: () => props.portalConfigurationPresentationDialog,
      set: (value) => {
        emit("update:portalConfigurationPresentationDialog", value);
      },
    });

    const {
      initConfigurationForm,
      portalConfigurationFormRef,
      portalProfile,
      hasBasicPresentation,
      hasFullPresentation,
    } = usePortalConfiguration();

    const parentPortalConfiguration = initConfigurationForm(props);

    watch(
      () => parentPortalConfiguration.basic_presentation.access,
      function (newValue, oldValue) {
        if (
          newValue != oldValue &&
          newValue != null &&
          newValue.length > 1 &&
          newValue.includes("clickToConnect")
        ) {
          parentPortalConfiguration.basic_presentation.access = [
            "clickToConnect",
          ];
        }
      }
    );

    watch(
      () => parentPortalConfiguration.full_presentation.access,
      function (newValue, oldValue) {
        if (
          newValue != oldValue &&
          newValue != null &&
          newValue.length > 1 &&
          newValue.includes("clickToConnect")
        ) {
          parentPortalConfiguration.full_presentation.access = [
            "clickToConnect",
          ];
        }
      }
    );

    const isBasicClickToConnectChecked = (access) => {
      if (
        access != "clickToConnect" &&
        parentPortalConfiguration.basic_presentation.access.includes(
          "clickToConnect"
        )
      ) {
        return true;
      }
      return false;
    };

    const isFullClickToConnectChecked = (access) => {
      if (
        access != "clickToConnect" &&
        parentPortalConfiguration.full_presentation.access.includes(
          "clickToConnect"
        )
      ) {
        return true;
      }
      return false;
    };

    return {
      isBasicClickToConnectChecked,
      isFullClickToConnectChecked,
      hasBasicPresentation,
      hasFullPresentation,
      parentPortalConfiguration,
      portalProfile,
      portalConfigurationFormRef,
      parentPortalConfigurationPresentationDialog,
    };
  },
};
</script>
